import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListItemProps,
  Typography,
} from "@mui/material";
import { OpenInNew, PictureAsPdf } from "@mui/icons-material";

export const ListItemGuideBook = (props: ListItemProps) => {
  return (
    <>
      <ListItemButton
        target="_blank"
        href="https://docs.google.com/document/d/1lWHjWW-FyvSTeCTxtPCZioJJ8SOH1vy_vHMXSTCxLc0/edit?usp=drive_link"
        rel="noreferrer"
      >
        <ListItemIcon>
          <PictureAsPdf />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography
              sx={{
                verticalAlign: "bottom",
                display: "inline-flex",
                alignItems: "center",
              }}
              {...props}
            >
              ガイドブック
              <OpenInNew fontSize="small" sx={{ ml: 0.25 }} />
            </Typography>
          }
        />
      </ListItemButton>
    </>
  );
};
